import { del, get, post, put } from '../utils/axios'

export const getTeamsAPI = async (param) => {
  return await get('teams',param)
}

export const createTeamsAPI = async (body) => {
  return await post('teams', body)
}

export const updateTeamsAPI = async (param, body) => {
  return await put('teams', param, body)
}

export const deleteTeamsAPI = async (param) => {
  return await del('teams', param)
}

export const getTeamsExpandAPI = async (param) => {
  return await get('search/team/th-eng',param)
}

